import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as CoreActions from '@app/core/store/core.action';
import { selectCoreState, selectIsNavOpen, showErrorMessage } from '@app/core/store/core.selectors';
import { selectCountsCurrentIdState } from '@app/modules/counts/store/selectors/counts.selectors';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs';

@Component({
  templateUrl: './modal-excel-report.component.html',
  styleUrls: ['./modal-excel-report.component.scss']
})

export class ModalExcelReportComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  public disabled: boolean = true;
  constructor(
    private _store: Store,
    private _translation: TranslateService,
    private _matDialog: MatDialog,
    private router: Router,
    private _inventory: InventoryService,
    private _toaster: ToastrService,
    private dialogRef: MatDialogRef<ModalExcelReportComponent>
  ) { }
  
  ngOnInit(): void {
  }

  onCheckInputEvent(event) {
    this.disabled = !this.form.valid;
    if (event.key === 'Enter' && !this.disabled) {
      document.getElementById('SendMailModal__submitButton').click();
    }
  }

  onGenerateExcel(){
    this._store.select(selectCountsCurrentIdState).pipe(first()).subscribe((res) => {
      this._inventory.onGetExcel(res).pipe(first()).subscribe((data:any)=> {
        const headers = ["SKU", "Product Description", "Product Storage", "Brand", "UOM", "MSL1", "MSL2", "Category", "Cost Price", "Retail Price", "Count Type",
        "Count Type Quantity", "Custom Product Field", "Custom Product Field2", "Count", "Total Cost", "Total Retail", "Total Avail"];
        this._inventory.onExcelCount(headers, data.inv, data.invItems);
      });
    });
  }

  sendReportMail() {
    const email = this.form.get('email').value;
    const dataToSend = { email: email }; 
    this.dialogRef.close(dataToSend);
    this._toaster.success("The report has been sent to the requested email.");
  }

}

